
import { useState } from "react";
// import { Upload } from 'tus-js-client'; // Removed - using standard multipart upload instead

import axios from "axios";
//import AWS from "aws-sdk";
import fileSaver from "file-saver";
import authHeader from "../helpers/header";
import helper from "../helpers/query";
import apiInstance from "./api";
import { API_URL, NODE_URL } from "../configs";

/**
 * Convert vector file to PNG by uploading the file
 * @param {FormData} formData
 * @returns {Promise}
 */
const convertVectorToPng = async (formData) => {
  // POST to /convert_vector with the file
  return apiInstance.post(
    API_URL + "files/convert_vector",
    formData,
    {
      headers: {
        ...authHeader(),
        "Content-Type": "multipart/form-data"
      },
      withCredentials: true
    }
  );
};

/**
 * Verify if file exists in a specific storage
 * @param {string} fileId
 * @param {string} storageType
 * @returns {Promise}
 */
const verifyFileExist = async (fileId, storageType) => {
  // storageType: 'local', 'aws_path', etc.
  return apiInstance.get(`${API_URL}files/verify/${fileId}?storage=${storageType}`, {
    headers: authHeader(),
    withCredentials: true
  });
};

// send preview file to upload *** OLD METHOD ***
const uploadPreview = async (data) => {
  const response = await apiInstance.post(`${API_URL}files/upload`, data, {
    headers: authHeader(),
    withCredentials: true
  });
  return response.data;
};

// send preview image to upload
//const useUploadForm = (url: string) => {
const useUploadPreview = () => {
  const [previewProgress, setPreviewProgress] = useState(0);
  const [previewUploadError, setPreviewUploadError] = useState();

  const previewProcess = async (formData, type = "resource") => {
    setPreviewUploadError("");
    // Ensure 'type' is included in FormData
    if (formData instanceof FormData && !formData.has("type")) {
      formData.append("type", type);
    }
    return await apiInstance.post(`${API_URL}files/upload_image`, formData, {
      headers: {
        ...authHeader(),
        "Content-Type": "multipart/form-data"
      },
      withCredentials: true,
      onUploadProgress: (data) => {
        setPreviewProgress(Math.round((100 * data.loaded) / data.total));
      }
    }).then((response) => {
      return response;
    }).catch(function(error) {
      setPreviewUploadError(error.response?.data?.detail || error.message);
    });
  };
  return { previewProcess, previewProgress, previewUploadError };
};

const useUploadBannerEvent = () => {
  //const [isSuccess, setIsSuccess] = useState(false);
  const [previewProgress, setPreviewProgress] = useState(0);
  const [previewUploadError, setPreviewUploadError] = useState();

  const previewProcess = async (formData) => {
    setPreviewUploadError("");
    return await apiInstance.post(`${API_URL}files/upload_event_banner`, formData, {
      headers: {
        ...authHeader(),
        "Content-Type": "multipart/form-data"
      },
      withCredentials: true,
      onUploadProgress: (data) => {
        //Set the progress value to show the progress bar
        setPreviewProgress(Math.round((100 * data.loaded) / data.total));
      }
    }).then((response) => {
      return response;
    }).catch(function(error) {
      setPreviewUploadError(error.response.data.detail);
    });
  };
  return { previewProcess, previewProgress, previewUploadError };
};

// send file to upload *** OLD METHOD ***
const uploadFile = async (data) => {
  const response = await apiInstance.post(`${API_URL}files/upload`, data, {
    headers: authHeader(),
    withCredentials: true
  });
  return response.data;
};

// send file to upload
const useUploadFile = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [fileUploadError, setFileUploadError] = useState();
  const [progress, setProgress] = useState(0);

  // file: File object, onProgress: callback (optional)
  const fileProcess = async (file, { onProgress } = {}) => {
    console.log('🚀 Starting upload for file:', file?.name);
    console.log('📊 File size:', file?.size, 'bytes', `(${(file?.size / 1024 / 1024).toFixed(2)} MB)`);
    console.log('🔧 onProgress callback provided:', typeof onProgress === 'function');
    
    setFileUploadError("");
    setIsLoading(true);
    setProgress(0);
    
    try {
      // Use uploadWithTus for upload (now using standard multipart)
      const response = await uploadWithTus(file, {
        onProgress: (percent) => {
          const numericPercent = parseFloat(percent);
          console.log('📈 Progress update:', numericPercent + '%');
          setProgress(numericPercent);
          if (onProgress && typeof onProgress === 'function') {
            console.log('📤 Calling external onProgress callback with:', numericPercent);
            onProgress(numericPercent);
          }
        },
        onSuccess: (url) => {
          console.log('✅ Upload success callback triggered, URL:', url);
          setIsLoading(false);
          setProgress(100);
        },
        onError: (err) => {
          console.error('❌ Upload error in fileProcess:', err);
          setFileUploadError(err?.message || err);
          setIsLoading(false);
          setProgress(0);
        },
      });
      
      console.log('🎉 Upload completed successfully');
      setIsLoading(false);
      setProgress(100);
      return response;
    } catch (error) {
      console.error('💥 File upload failed:', {
        status: error?.response?.status,
        data: error?.response?.data,
        message: error?.message
      });
      setFileUploadError(error?.response?.data?.detail || error.message);
      setIsLoading(false);
      setProgress(0);
      throw error;
    }
  };
  return { fileProcess, isLoading, fileUploadError, progress };
};

// Standard multipart upload (formerly TUS-based)
export async function uploadWithTus(file, { onProgress, onSuccess, onError }) {
  // Use standard multipart upload to match backend /files/upload_file endpoint
  const endpoint = `${API_URL}files/upload_file`;
  
  console.log('🌐 Upload endpoint:', endpoint);
  console.log('📁 File details:', {
    name: file?.name,
    size: file?.size,
    type: file?.type
  });
  
  // Create FormData for multipart upload - match working pattern from useUploadPreview
  const formData = new FormData();
  formData.append('data', file);  // Backend expects 'data' parameter
  
  try {
    console.log('📤 Starting axios upload request...');
    
    // Use axios for the upload with progress tracking
    const response = await apiInstance.post(endpoint, formData, {
      headers: {
        ...authHeader(),
        'Content-Type': 'multipart/form-data'
      },
      withCredentials: true,
      timeout: 600000, // 10 minutes timeout for large file uploads
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        const percentage = ((loaded / total) * 100).toFixed(2);
        
        console.log('📊 Upload progress:', {
          loaded: `${(loaded / 1024 / 1024).toFixed(2)} MB`,
          total: `${(total / 1024 / 1024).toFixed(2)} MB`,
          percentage: percentage + '%'
        });
        
        if (onProgress && typeof onProgress === 'function') {
          onProgress(percentage);
        } else {
          console.warn('⚠️ onProgress callback not available or not a function');
        }
      }
    });
    
    console.log('✅ Upload response received:', {
      status: response.status,
      data: response.data
    });
    
    if (onSuccess && typeof onSuccess === 'function') {
      const filePath = response.data.filepath || response.data.filename;
      console.log('🎯 Calling onSuccess with filepath:', filePath);
      onSuccess(filePath);
    }
    
    return response;
  } catch (error) {
    console.error('💥 Upload request failed:', {
      status: error?.response?.status,
      statusText: error?.response?.statusText,
      data: error?.response?.data,
      message: error?.message
    });
    
    // Enhanced error handling to prevent logout on file size errors
    let errorMessage = error?.response?.data?.detail || error.message;
    
    // Check for file size related errors specifically
    if (error?.response?.status === 413 || error?.response?.status === 422) {
      // 413 Payload Too Large or 422 Unprocessable Entity (FastAPI validation)
      if (errorMessage.includes('too large') || errorMessage.includes('size') || error?.response?.status === 413) {
        errorMessage = `File size too large. Maximum allowed size is exceeded.`;
      } else if (error?.response?.status === 422) {
        errorMessage = `File validation failed: ${errorMessage}`;
      }
    } else if (error?.response?.status === 403) {
      // For 403 errors, provide more specific messaging
      errorMessage = `Access denied. This could be due to file size limits or permissions: ${errorMessage}`;
    }
    
    console.log('🔥 Final error message:', errorMessage);
    
    if (onError && typeof onError === 'function') {
      onError(errorMessage);
    }
    
    throw error;
  }
}

// request all file with query
const getAllFiles = async (query) => {
  let newQuery = {};

  Object.keys(query).map((item) => {
    if (query[item]) {
      switch (item) {
        case "page":
          newQuery.offset = parseInt(query.page) - 1;
          break;
        case "pageSize":
          newQuery.limit = parseInt(query.pageSize);
          break;
        default:
          newQuery[item] = query[item];
          break;
      }
    }
  });

  let q = helper.arrayToQueryString(newQuery);

  const response = await apiInstance.get(API_URL + `files/?${q}`, {
      headers: authHeader(),
      withCredentials: true 
    }
  );
  return response.data;
};

// get all ai files
const getAiFiles = async (query) => {
  let newQuery = {
    // format: "ai",
  };

  Object.keys(query).map((item) => {
    if (query[item]) {
      switch (item) {
        case "page":
          newQuery.offset = parseInt(query.page) - 1;
          break;
        case "pageSize":
          newQuery.limit = parseInt(query.pageSize);
          break;
        default:
          newQuery[item] = query[item];
          break;
      }
    }
  });

  let q = helper.arrayToQueryString(newQuery);
  const response = await axios.get(
    `${NODE_URL}/api/resource/getAllAiFiles?${q}`
  );
  return response.data;
};

// get resource files
const getResourceFiles = (resourceId) => {
  return apiInstance.get(API_URL + `files/by_resource/${resourceId}`, { headers: authHeader(), withCredentials: true });
};

// get files from same resource
const getFilesSameResources = (fileId) => {
  return apiInstance.get(API_URL + `files/related_resource/${fileId}`, { headers: authHeader(), withCredentials: true });
};

// get B2 signed url
const getB2SignedUrl = async (fileId) => {
  const resp = await apiInstance.get(API_URL + `files/b2_signed_url/${fileId}`, { headers: authHeader(), withCredentials: true });
  return resp.data;
};
// send create resource request
const createResourceFile = (data) => {
  console.log(data.storage_locations);
  // Compose storage_locations array from data
  // const storageLocation = {
  //   storage_type: data.storage_type, // e.g., 'backblaze_b2'
  //   path: data.path, // e.g., file path in storage
  //   uploaded_at: data.uploaded_at, // ISO string
  //   file_id: data.file_id, // storage provider file id
  //   size: data.file_size,
  //   status: data.status || 'active',
  //   migrated_from: data.migrated_from || null,
  //   metadata: data.metadata || null,
  // };
  return apiInstance.post(
    API_URL + "files",
    {
      filename: data.filename,
      resourceId: data.resourceId,
      format: data.format,
      file_size: data.file_size,
      storage_locations: data.storage_locations || [],
    },
    { headers: authHeader(), withCredentials: true }
  );
};

// send delete request
const deleteFile = (fileId) => {
  return axios.delete(API_URL + `files/${fileId}`, { headers: authHeader(), withCredentials: true });
};

// hard delete file (permanently removes from database and storage)
const hardDeleteFile = async (fileId) => {
  return apiInstance.delete(API_URL + `files/hard_delete/${fileId}`, {
    headers: authHeader(),
    withCredentials: true
  });
};

// Delete file from specific storage type
const deleteFileFromStorage = async (fileId, storageType) => {
  try {
    const response = await apiInstance.delete(`files/storage/${fileId}/${storageType}`, {
      headers: authHeader(),
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error(`Error deleting file from ${storageType}:`, error);
    throw error;
  }
};

// active a file
const updateFile = (fileId, data) => {
  return axios.put(API_URL + `files/${fileId}`, { data }, { headers: authHeader(), withCredentials: true });
};

/**
 * Convert vector file to PNG by file id
 * @param {string} file_id
 * @returns {Promise}
 */
const convertVectorById = async (file_id) => {
  // Use POST as per backend route
  return apiInstance.post(
    API_URL + `files/convert_vector_by_id/${file_id}`,
    {},
    { headers: authHeader(), withCredentials: true }
  );
};

// scan all ai files
const scanAllAiFiles = async () => {
  const res = await axios.get(`${NODE_URL}/api/resource/scanAllAiFiles`);
  return res;
};

/**
 * get file detail by file_id
 * @param {str} file_id
 * @returns json data
 */
const getFileById = async (file_id) => {
  const res = await apiInstance.get(API_URL + `files/${file_id}`, { headers: authHeader(), withCredentials: true });
  return res;
};

/**
 * check if file storage path death or alive
 * @param {str} file_id
 * @returns json data
 */
const checkFileExist = async (file_id) => {
  const res = await apiInstance.get(API_URL + `files/checkexist${file_id}`, { headers: authHeader(), withCredentials: true });
  return res;
};

/**
 * convert file ai to eps
 * @param {str} fileai_id
 * @returns json data
 */
const convertAItoEPS = async (file_id) => {
  const res = await axios.get(
    `${NODE_URL}/api/resource/convert/ai-eps/by_resource_id/${file_id}`
  );
  return res;
};

/**
 * convert file ai to eps
 * @param {str} fileai_id
 * @returns json data
 */
const convertAItoSVG = async (file_id) => {
  const res = await axios.get(
    `${NODE_URL}/api/resource/convert/ai-svg/by_resource_id/${file_id}`
  );
  return res;
};

/**
 * download file from AWS
 * @param {str} filepath
 * @param {str} filename
 * @returns blob data
 */
// const downloadS3 = (filepath, filename) => {
//   const s3 = new AWS.S3();
//   s3.config.update({
//     accessKeyId: S3_KEY,
//     secretAccessKey: S3_SECRET,
//     region: S3_REGION,
//     endpoint: `s3-${S3_REGION}.amazonaws.com`,
//     signatureVersion: "v4",
//   });
//   console.log({
//     accessKeyId: S3_KEY,
//     secretAccessKey: S3_SECRET,
//     region: S3_REGION,
//     endpoint: `s3-${S3_REGION}.amazonaws.com`,
//     signatureVersion: "v4",
//   })
//   const params = { Bucket: S3_BUCKET, Key: filepath };
//   s3.getSignedUrl("getObject", params, function (err, url) {
//     // console.log("Your generated pre-signed URL is", url);
//     axios.get(`${url}`, { responseType: "blob" }).then((res) => {
//       const blob = new File([res.data], `${filename}`);
//       fileSaver.saveAs(blob);
//     });
//   });
// };

const exportedObject = {
  uploadPreview,
  uploadFile,
  deleteFile,
  hardDeleteFile,
  deleteFileFromStorage,
  updateFile,
  createResourceFile,
  getResourceFiles,
  getFilesSameResources,
  getAllFiles,
  useUploadPreview,
  useUploadFile,
  getAiFiles,
  scanAllAiFiles,
  getFileById,
  checkFileExist,
  convertAItoEPS,
  convertAItoSVG,
  useUploadBannerEvent,
  convertVectorById,
  convertVectorToPng,
  getB2SignedUrl,
  verifyFileExist,
  //downloadS3
};

export default exportedObject;
